import Immutable from 'immutable';

import {
	webapi,
	createModuleState,
	REPORTED_EXCEPTION
} from 'ps-gui';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_LIST = Immutable.List([]);
const EMPTY_STATE = createModuleState('SystemSettings');

export default class SystemSettingsModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}

	async initialize() {
		let model = new SystemSettingsModel(this.#data.set('initialized', true));
		return await model.load();
	}

	async load() {
		const res = await webapi.execute('/api/proc/api_systemsettings/getSystemSettings');
		if (res === REPORTED_EXCEPTION) {
			return this;
		}
		const detail = Immutable.fromJS(res);
		return new SystemSettingsModel(this.#data.set('initialized', true).set('detail', detail).set('originalDetail', detail));
	}

	async save() {
		const res = await webapi.execute('/api/proc/api_systemsettings/saveSystemSettings', this.#data.get('detail').toJS());
		if (res === REPORTED_EXCEPTION) {
			return this;
		}
		return this.load();
	}

	/**
	 * Nastaví hodnotu do configu
	 * @param {String} type // typ hodnoty, která se vkládá, zatím number/string/date
	 * @param {String} name // název položky, která se nastavuje v configu, např. logoutWarningThreshold
	 * @param {Number} value
	 * @returns void
	 */
	setConfigProperty(type, name, value) {
		return new SystemSettingsModel(this.#data.setIn([
			'detail',
			'config',
			name,
			type + 'Value'
		], value));
	}

	/**
	 * Uloží novou délku času expirace session pro zadaný typ přihlášení
	 * Naktualizuje dat s databází
	 * @param {String} loginTypeId // pro koho se nastavuje nová délka session, např. HADMIN/HARMONEY
	 * @param {Number} value 
	 * @returns void
	 */
	setSessionDuration(loginTypeId, value) {
		let loginTypes = this.#data.getIn(['detail', 'loginTypes']);
		if (!loginTypes) {
			return this;
		}
		const index = loginTypes.findIndex(loginType => loginType.get('id') === loginTypeId);
		if (index < 0) {
			return this;
		}
		return new SystemSettingsModel(this.#data.setIn([
			'detail',
			'loginTypes',
			index,
			'sessionDuration'
		], value));
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}

	getLoginTypes() {
		return this.#data.getIn(['detail', 'loginTypes']) || EMPTY_LIST;
	}

	// Vrací hodnotu (počet minut), než se upozorní uživatel před automatickým ohlášením
	getWarningThreshhold() {
		return this.#data.getIn([
			'detail',
			'config',
			'logoutWarningThreshold',
			'numberValue'
		]);
	}

	setWarningThreshhold(value) {
		return this.setConfigProperty('number', 'logoutWarningThreshold', value);
	}

	// Kontroluje, jestli se provedla jakákoli změna, a jestli tedy má smysl ukládat hodnoty
	isModified() {
		return this.#data.get('detail') !== this.#data.get('originalDetail');
	}
}

